import { render, staticRenderFns } from "./SchoolSetupGuide.vue?vue&type=template&id=1e880526&"
import script from "./SchoolSetupGuide.vue?vue&type=script&lang=js&"
export * from "./SchoolSetupGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports